<template>
  <div>
    <!-- Prenom -->
    <v-text-field
      v-model="renseignementsGeneraux.firstName"
      :rules="rules.firstName"
      label="Prénom"
      :disabled="disableNomPrenom"
      required
      class="cssRequired"
    ></v-text-field>
    <!-- Nom -->
    <v-text-field
      v-model="renseignementsGeneraux.lastName"
      :rules="rules.lastName"
      label="Nom"
      :disabled="disableNomPrenom"
      required
      class="cssRequired"
    ></v-text-field>
    <!-- Date de naissance readonly si inscription-->
    <v-menu
      ref="menu"
      v-model="dateMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
      :rules="rules.birthday"
      autocomplete="off"
      required
    >
      <template v-slot:activator="{ on, attrs }">
        <v-sheet max-width="200">
          <v-text-field
            v-model="renseignementsGeneraux.dateDeNaissance"
            label="Date de naissance"
            append-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
            :rules="rules.birthday"
            required
            class="cssRequired"
            v-mask="'####-##-##'"
            hint="Format YYYY-MM-DD"
            readonly
            :disabled="disableDateNaissance"
          />
        </v-sheet>
      </template>
      <v-date-picker
        ref="picker"
        v-model="renseignementsGeneraux.dateDeNaissance"
        :rules="rules.birthday"
        required
        class="cssRequired"
        @change="save"
        :max="new Date().toISOString().substr(0, 10)"
        :active-picker.sync="activePicker"
      />
    </v-menu>

    <!-- Adresse -->
    <CanadaPost
      :text="canadaPostLabel"
      clef="contactDeBase"
      required
      cssClass="cssRequired"
      v-model="renseignementsGeneraux.adresse"
      @updateAdresse="updateRenseignementGenerauxAddress"
      @manualEntry="updateAdresseFromManualEntry"
    />

    <!-- Code Postal -->
    <v-text-field
      v-model="renseignementsGeneraux.codePostal"
      :rules="rules.postalCode"
      label="Code Postal"
      required
      class="cssRequired"
    ></v-text-field>
    <!-- Ville -->
    <v-text-field v-model="renseignementsGeneraux.ville" :rules="rules.ville" label="Ville" required class="cssRequired"></v-text-field>
    <!-- Province -->
    <v-autocomplete
      v-model="renseignementsGeneraux.provinceOuEtatSiApplicable"
      :items="listeProvincesFilter"
      :item-text="itemText"
      :item-value="itemValue"
      label="Province ou État si applicable"
      :rules="rules.provinceOuEtatSiApplicable"
      required
      class="cssRequired"
      return-object
      @change="modelChange()"
    ></v-autocomplete>
    <!-- Pays -->
    <v-autocomplete
      v-model="renseignementsGeneraux.pays"
      :items="listePays"
      :item-text="itemText"
      :item-value="itemValue"
      label="Pays"
      :disabled="renseignementsGeneraux.pays && disablePaysRenseigne"
      @change="paysChange()"
      :rules="rules.pays"
      required
      class="cssRequired"
      return-object
    ></v-autocomplete>
    <!-- Email -->
    <v-text-field
      v-model="renseignementsGeneraux.courriel"
      :rules="rules.email"
      type="email"
      label="Courriel de correspondance*"
      required
      class="cssRequired"
    ></v-text-field>
    <p class="mb-6 warning-text" style="font-weight: bold">
      *L'ordre utilisera cette adresse électronique pour correspondre avec vous. Il est de votre responsabilité d'inscrire un courriel valide que vous
      consultez régulièrement ainsi que de consulter vos courriers indésirables.
    </p>
    <!-- Cellulaire -->
    <v-phone-input
      v-model="renseignementsGeneraux.cellulaire"
      :label="cellulaireLabel"
      :rules="rules.cellulaire"
    ></v-phone-input>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import CanadaPost from "../common/canadaPost/CanadaPost"

export default {
  components: {
    CanadaPost: CanadaPost,
  },
  props: {
    renseignementsGeneraux: Object,
    rules: Object,
    isDemandeAdmissionPublique: {
      type: Boolean,
      default: false
    },
    disableDateNaissance: {
      type: Boolean,
      default: false
    },
    disableNomPrenom: {
      type: Boolean,
      default: false
    },
    disablePaysRenseigne: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateMenu: false,
      canadaPostLabel: "Adresse",
      activePicker: null
    }
  },
  created() {
    this.fetchItems()
  },
  computed: {
    ...mapGetters({
      listeProvinces: "Catalogue/GET_PROVINCES",
      listePays: "Catalogue/GET_PAYS"
    }),
    cellulaireLabel() {
      return this.isDemandeAdmissionPublique == true ? "Téléphone" : "Cellulaire"
    },
    listeProvincesFilter() {
      return this.listeProvinces.filter((p) => this.renseignementsGeneraux.pays != null && p.parent == this.renseignementsGeneraux.pays.id)
    }
  },
  watch: {
    dateMenu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"))
    }
  },
  methods: {
    ...mapMutations({
      updateAddressFromCanadaPost: "RenseignementsGeneraux/updateAddressFromCanadaPost",
      updateAddressFromCanadaPostWithManualEntry: "RenseignementsGeneraux/updateAddressFromCanadaPostWithManualEntry",
      setRenseignementsGeneraux: "RenseignementsGeneraux/setRenseignementsGeneraux"
    }),
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue"
    }),
    async fetchItems() {
      // Catalogue Province
      await this.getCatalogue(313)
      // Catalogue Pays
      await this.getCatalogue(303)
      if (this.renseignementsGeneraux.pays == null) {
        this.renseignementsGeneraux.pays = this.listePays.find((p) => p.id === this.$catalogues.pays.canada)
      }

      if (this.renseignementsGeneraux.provinceOuEtatSiApplicable == null && this.renseignementsGeneraux.pays.id === this.$catalogues.pays.canada) {
        this.renseignementsGeneraux.provinceOuEtatSiApplicable = this.listeProvinces.find((p) => p.id === this.$catalogues.province.quebec)
      }
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    save(date) {
      this.$refs.menu.save(date)
    },
    validate() {
      this.setRenseignementsGeneraux(this.renseignementsGeneraux)
      this.$emit("validate-form")
    },
    modelChange() {
      this.$nextTick(() => {
        this.model = null
      })
    },
    paysChange() {
      this.modelChange()
      this.renseignementsGeneraux.provinceOuEtatSiApplicable = null
      this.validate()
    },
    updateRenseignementGenerauxAddress(payload) {
      this.updateAddressFromCanadaPost({ address: payload, listePays: this.listePays, listeProvinces: this.listeProvinces })
    },
    updateAdresseFromManualEntry(payload) {
      this.updateAddressFromCanadaPostWithManualEntry({ address: payload })
    }
  }
}
</script>

<style>
</style>